import React from 'react'
import { Icon } from 'semantic-ui-react'

const NotificationSettingsIcon = () => {
  return (
    <div style={{ position: 'relative' }}>
      {/* <Icon name="bell" color='yellow' size="large" style={{ position: 'relative', zIndex: 2 }} /> */}
      <img
        src='https://img.icons8.com/?size=100&id=6oSO0y87LIU5&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
        alt='Notificaciones'

        style={{ width: 25, height: 25, verticalAlign: 'middle', position: 'relative', zIndex: 2 }}
      />

      <img
        src='https://img.icons8.com/?size=100&id=N5JNmydXBuCl&format=png&color=000000'
        alt='Notificaciones'
        style={{ width: 25, height: 25, display: 'inline-block', verticalAlign: 'middle', position: 'absolute', top: -5, right: -5, zIndex: 1, fontSize: 12 }}
      />
      {/* <Icon name="setting" size='large' style={{ position: 'absolute', top: -4, right: -4, zIndex: 1, fontSize: 12, }} /> */}
    </div>
  )
}

export default NotificationSettingsIcon